import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { Typography } from '../../theme';
import { media } from '../../utils/styled';
import Heading from './Heading';
import Stack from './Stack';

const Section: React.FC<{
  title: string;
  titleVariant?: Typography;
  graphic?: ReactNode;
  reversed?: boolean;
  id?: string;
  children?: ReactNode;
  contentFlex?: number;
  graphicFlex?: number;
}> = ({
  title,
  titleVariant = 'title-2',
  graphic,
  reversed = false,
  id,
  children,
  contentFlex = 3,
  graphicFlex = 2,
}) => {
  const content = (
    <Stack
      spacing="large"
      axis="y"
      style={{
        flex: contentFlex,
      }}
    >
      <Heading
        variant={titleVariant}
        blockColor={reversed ? 'yellow' : 'primary-dark'}
      >
        {title}
      </Heading>

      {children}
    </Stack>
  );

  return (
    <Stack
      id={id}
      axis={{ _: 'x', mdDown: 'y' }}
      justify="space-between"
      spacing={{ _: 'xxxlarge', mdDown: 'large' }}
      reverse={{ _: reversed, mdDown: false }}
      as="section"
    >
      <>
        {content}

        {graphic && <Graphic flex={graphicFlex}>{graphic}</Graphic>}
      </>
    </Stack>
  );
};

const Graphic = styled.div<{ flex: number }>`
  width: 100%;
  flex: ${(p) => p.flex};

  ${media.mdDown`
    max-width: 500px;
  `}
`;

export default Section;
